import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c143a10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-a-zu542" }, null, -1))
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "mask" }
const _hoisted_5 = {
  key: 0,
  class: "live orange"
}
const _hoisted_6 = {
  key: 1,
  class: "live red"
}
const _hoisted_7 = {
  key: 2,
  class: "live gray"
}
const _hoisted_8 = {
  key: 3,
  class: "live blue"
}
const _hoisted_9 = { class: "c-primary" }
const _hoisted_10 = { class: "c-thirdary" }
const _hoisted_11 = { class: "c-thirdary" }

import lives, { State } from '@/store/lives/home';
import * as filters from '@/views/filters';
import { computed } from 'vue';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[lives.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].live)


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("span", null, _toDisplayString(_unref(lang).channel), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).lives, (item) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          class: _normalizeClass(["item", { on: _unref(data).live && _unref(data).live.id == item.id }]),
          to: `/lives/${item.id}/index.html`
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "poster",
              style: _normalizeStyle(_unref(filters).bg(item.thumb))
            }, [
              _createElementVNode("div", _hoisted_4, [
                (item.push_status == 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(lang).live_wait), 1))
                  : _createCommentVNode("", true),
                (item.push_status == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(lang).live_play), 1))
                  : _createCommentVNode("", true),
                (item.push_status == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(lang).live_end), 1))
                  : _createCommentVNode("", true),
                (item.push_status == 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(lang).live_replay), 1))
                  : _createCommentVNode("", true)
              ])
            ], 4),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(lang).live_start) + "：" + _toDisplayString(_unref(filters).datetime(item.starttime)), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(lang).live_viewCount) + "：" + _toDisplayString(item.hits), 1)
          ]),
          _: 2
        }, 1032, ["class", "to"]))
      }), 256))
    ])
  ]))
}
}

})